export default import.meta.ROLLDOWN_FILE_URL_btLZxow_chTA2Vu8CDdmtA